function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4028 9.20392L13.9443 8.66244C15.4099 7.19683 17.7847 7.19683 19.2503 8.66244L24.8939 14.306C26.7084 16.1205 26.7084 19.0618 24.8939 20.8763L24.6175 21.1526C22.803 22.9671 19.8618 22.9671 18.0473 21.1526L13.6542 16.7596",
  stroke: "#2E3584",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.87392 18.1426C5.0269 17.2197 3.74512 15.3302 3.74512 13.1243C3.74512 10.0167 6.26492 7.49695 9.37246 7.49695C12.48 7.49695 14.9998 10.0167 14.9998 13.1243C14.9998 15.329 13.7193 17.2185 11.8735 18.1414V18.1389L11.8723 23.7587C11.871 24.0889 11.7397 24.4052 11.5058 24.6378L10.2528 25.8909C9.76512 26.3773 8.9773 26.3761 8.49084 25.8896L7.23657 24.6328C7.00272 24.399 6.87142 24.0814 6.87142 23.7512L6.87392 18.1401",
  stroke: "#2E3584",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.37256 12.8116V7.18429C9.37256 5.28475 10.9119 3.74536 12.8115 3.74536V3.74536C14.711 3.74536 16.2504 5.28475 16.2504 7.18429V7.58071",
  stroke: "#2E3584",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.37131 12.8117C9.19874 12.8117 9.05868 12.9517 9.06118 13.1243C9.06118 13.2969 9.20124 13.4369 9.37381 13.4369C9.54638 13.4369 9.68644 13.2969 9.68644 13.1243C9.68519 12.9517 9.54513 12.8117 9.37131 12.8117",
  stroke: "#2E3584",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgJoratoTenants = function SvgJoratoTenants(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoTenants, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-tenants.e479146e.svg";
export { ForwardRef as ReactComponent };